import React from 'react';
export const InProgressIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.027 12.8251C14.626 15.3986 11.9302 17.0003 9 17.0001C4.58172 17.0001 1 13.4183 1 9.00006L1 9.00128C0.999999 13.4196 4.58172 17.0013 9 17.0013C11.9309 17.0013 14.6271 15.3986 16.0276 12.824M5.047 5.17506H1.512V1.63906M12.953 12.8251H16.488V16.3611M17 9.00006C17 4.58178 13.4183 1.00006 9 1.00006C6.06983 0.999813 3.37399 2.60152 1.973 5.17506C4.08481 1.29416 8.94287 -0.139983 12.8238 1.97184C15.3982 3.37271 17.0004 6.0692 17 9.00006Z"
      stroke="#111111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
